"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _icon = _interopRequireDefault(require("./icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarIcon = function CalendarIcon(props) {
  var id = props.id,
      className = props.className;
  return _react.default.createElement(_icon.default, {
    id: id ? id : null,
    className: className
  }, _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", {
    id: id ? "".concat(id, "_title") : null
  }, "calendar"), _react.default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _react.default.createElement("g", {
    id: "info"
  }, _react.default.createElement("rect", {
    x: "2.14",
    y: "6.81",
    width: "1.94",
    height: "1.94"
  }), _react.default.createElement("rect", {
    x: "6.03",
    y: "6.81",
    width: "1.94",
    height: "1.94"
  }), _react.default.createElement("rect", {
    x: "9.92",
    y: "6.81",
    width: "1.94",
    height: "1.94"
  }), _react.default.createElement("rect", {
    x: "2.14",
    y: "10.69",
    width: "1.94",
    height: "1.94"
  }), _react.default.createElement("rect", {
    x: "6.03",
    y: "10.69",
    width: "1.94",
    height: "1.94"
  }), _react.default.createElement("rect", {
    x: "9.92",
    y: "10.69",
    width: "1.94",
    height: "1.94"
  }), _react.default.createElement("path", {
    d: "M11.67,1.56V.78a.78.78,0,0,0-1.56,0v.78H3.89V.78a.78.78,0,0,0-1.56,0v.78H0V14.78H14V1.56Zm1.75,12.64H.58V5.25H13.42Z"
  })))));
};

var _default = CalendarIcon;
exports.default = _default;